import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageTile: {
    id: 'notFoundPage.title',
    defaultMessage: 'Error - Invalid/Incomplete URL'
  },
  pageDescription: {
    id: 'notFoundPage.description',
    defaultMessage: "The requested workscope cannot be accessed directly. Please verify your URL or return to the dashboard using the button below."
  },
  homePageButton: {
    id: 'notFoundPage.homePageButton',
    defaultMessage: 'Go back to Dashboard'
  },
  errorImageText: {
    id: 'notFoundPage.errorImageText',
    defaultMessage: 'Error Image'
  },
  homePage: {
    id: 'notFoundPage.homePageLinkLabel',
    defaultMessage: 'Visit Home'
  },
});

